import { render, staticRenderFns } from "./Banner2.vue?vue&type=template&id=6b93c0ba&scoped=true&"
import script from "./Banner2.vue?vue&type=script&lang=js&"
export * from "./Banner2.vue?vue&type=script&lang=js&"
import style0 from "./Banner2.vue?vue&type=style&index=0&id=6b93c0ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b93c0ba",
  null
  
)

export default component.exports